import { render } from "./QuickDialog.vue?vue&type=template&id=7e5b80e1&scoped=true"
import script from "./QuickDialog.vue?vue&type=script&lang=js"
export * from "./QuickDialog.vue?vue&type=script&lang=js"

import "./QuickDialog.vue?vue&type=style&index=0&id=7e5b80e1&lang=scss&scoped=true"

import exportComponent from "/Users/shuaqq/Desktop/jysports/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e5b80e1"]])

export default __exports__